module.exports = __webpack_public_path__ + "img/trial3-3.fdbc69c2.png";